<div class="cf sectnav mobile-responsive" [ngClass]="{ 'mobile-responsive': consumerPortalWidth < 815 }">
    @if (appFacadeService.getActiveTab() | async; as activeTab) {
    <ul class="por-menu">
        @for (url of navigations; track url) {
        <li class="navigations theme-list-item">
            <por-base-button
                porAppPushState
                featureName="{{ url?.text }}-page"
                [tab]="url?.tab"
                [ngClass]="{ 'is-active': url?.tab === activeTab }"
                [theme]="url?.tab === activeTab ? 'primary' : 'secondary'"
                (click)="toggleTab(url?.tab)">
                <label porAddFeature featureName="{{ url?.text }}-page">{{ url?.text | uppercase }}</label>
            </por-base-button>
        </li>
        }
    </ul>
    }
</div>
